"use client"

import { useQuery } from "@tanstack/react-query"

import { useAuth } from "@/hooks/use-auth"
import { agentIntegrationStatusesQueryKey } from "@/hooks/queries/agent-integration-status-keys"
import { getQueryTenantId } from "@/lib/auth/query-tenant-id"
import type { AgentIntegrationStatus } from "@/lib/agents/shared/integration-status-types"
import type { DeliveryScopeType } from "@/lib/deliveries/config"
import { getAgentIntegrationStatusesAction } from "@/server-actions/agent-integration-statuses"

export function useAgentIntegrationStatusesQuery(
  scopeType: DeliveryScopeType,
  agentIds: string[],
  enabled = true,
) {
  const { user, isAuthenticated } = useAuth()
  const tenantId = getQueryTenantId(user)

  return useQuery<Record<string, AgentIntegrationStatus>>({
    queryKey: agentIntegrationStatusesQueryKey(tenantId, scopeType, agentIds),
    enabled: enabled && isAuthenticated && agentIds.length > 0,
    queryFn: async () => {
      const result = await getAgentIntegrationStatusesAction({
        scopeType,
        agentIds,
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result.statuses
    },
  })
}
